
export default {
  data() {
    return {
      videoSelected: 0,
      isCalendlyActive: false,
      isDesktop: false,
      videoLink: null,

      itemsList: [
        {
          title: "Plus de 120 sociétés",
        },
        {
          title: "Plus de 2000 collaborateurs",
        },
        {
          title: "Plus de 273 millions d’euros de CA en 2022",
        },
      ],

      values: [
        {
          img: require("~/assets/img/value-1.png"),
          img2: require("~/assets/img/value-1-x2.png"),
          title: "Liberté",
          text: "Libérer votre potentiel pour développer votre projet selon vos propres aspirations.",
          alt: "Propulser son activité avec ALEO",
        },
        {
          img: require("~/assets/img/value-2.png"),
          img2: require("~/assets/img/value-2-x2.png"),
          title: "Égalité",
          text: "Rendre accessible la communication à tous les entrepreneurs.",
          alt: "La communication accessible",
        },
        {
          img: require("~/assets/img/value-3.png"),
          img2: require("~/assets/img/value-3-x2.png"),
          title: "Empathie",
          text: "Vous guider dans votre projet en comprenant parfaitement vos enjeux.",
          alt: "Vous guidez dans vos projets de communication",
        },
        {
          img: require("~/assets/img/value-4.png"),
          img2: require("~/assets/img/value-4-x2.png"),
          title: "Performance",
          text: "Générer des résultats mesurables et tangibles à chaque action.",
          alt: "Résultat agence de communication",
        },
      ],

      videos: [
        {
          link: "https://www.youtube.com/embed/YKvJEtHpM_0",
          thumbnail: require("~/assets/img/thumb-video-1.png"),
          id: 0,
        },
        {
          link: "https://www.youtube.com/embed/6obQu9R-1MQ",
          thumbnail: require("~/assets/img/thumb-video-2.png"),
          id: 1,
        },
        {
          link: "https://www.youtube.com/embed/S-4inltCKow",
          thumbnail: require("~/assets/img/thumb-video-3.png"),
          id: 2,
        },
        {
          link: "https://www.youtube.com/embed/Roz-VIpMT1w",
          thumbnail: require("~/assets/img/thumb-video-4.png"),
          id: 3,
        },
      ],
    };
  },

  head() {
    return {
      title: " La communication au service des pros | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence fondée en 2021 révolutionne la communication pour répondre aux besoins des pros avec plus de 200 experts et un ambassadeur irrévocable",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "La communication au service des pros",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO révolutionne la communication pour répondre aux besoins des pros avec plus de 200 experts et un ambassadeur irrévocable",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-impulsion.jpg"),
        // },
      ],
    };
  },

  computed: {
    videoSorted() {
      return this.videos.filter((vid) => vid.id !== this.videoSelected);
    },
  },

  mounted() {
    this.watchMedia();
    this.lazyAdYt();
    this.activeVideo();
  },

  methods: {
    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);

      if (this.isDesktop) {
        setTimeout(() => {
          this.moonEffect();
        }, 800);
      }
    },

    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },

    moonEffect() {
      this.$gsap.to(".moon", {
        scrollTrigger: {
          trigger: ".moon",
          scrub: true,
          start: "top 80%",
        },
        y: "-20%",
        rotate: -40,
      });
    },

    activeVideo() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.videoLink =
              "https://www.youtube.com/embed/IHOAPBfFSPw?si=00ox2BLEqmVG3si_";
            io.unobserve(entry.target);
          }
        });
      });
      io.observe(this.$refs.video);
    },

    lazyAdYt() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.src = this.videos[0].link;
            io.unobserve(entry.target);
          }
        });
      });

      io.observe(this.$refs.adYt);
    },

    changeVideo(id) {
      this.$refs.adYt.src = this.videos[id].link;
      // this.videoSelected = id;
    },
  },
};
